/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [售后工单-待发布列表↗](http://yapi.yishou.com/project/128/interface/api/34008) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/getUnreasonListNotPublish`
 */
const getUnreasonListNotPublishRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/getUnreasonListNotPublish",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["work_id"],
        properties: { work_id: { type: "string", description: "售后工单id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string" },
                        goods_num: { type: "string", description: "件数" },
                        img: { type: "array", items: { type: "string" }, description: "图片" },
                        quick_remark: { type: "string" },
                        work_remark: { type: "string" },
                        status: { type: "string", description: "状态" },
                        remark: { type: "string", description: "备注" },
                        is_validate: { type: "string", description: "是否生效 1是 2否(可以删除)" },
                    },
                    required: ["is_validate"],
                },
            },
        },
    },
    requestFunctionName: "getUnreasonListNotPublish",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [售后工单-待发布列表↗](http://yapi.yishou.com/project/128/interface/api/34008) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/getUnreasonListNotPublish`
 */
export const getUnreasonListNotPublish = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getUnreasonListNotPublishRequestConfig, requestData), ...args);
};
getUnreasonListNotPublish.requestConfig = getUnreasonListNotPublishRequestConfig;
/**
 * 接口 [创建拒收工单↗](http://yapi.yishou.com/project/128/interface/api/34019) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/createUnreasonWord`
 */
const createUnreasonWordRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/createUnreasonWord",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "user_id",
            "work_id",
            "goods_no",
            "back_shipping_no",
            "unpacking_express_no",
            "as_refund_position",
            "goods_num",
            "img",
        ],
        properties: {
            user_id: { type: "string", description: "用户id" },
            work_id: { type: "string", description: "售后工单id" },
            goods_no: { type: "string", description: "商品货号" },
            back_shipping_no: { type: "string", description: "寄回运单号" },
            unpacking_express_no: { type: "string", description: "拆包运单号" },
            as_refund_position: { type: "string", description: "售后仓区" },
            goods_num: { type: "string", description: "商品件数" },
            quick_remark: { type: "string", description: "逗号间隔，快速备注，{1:领标缺失, 2:领标坏, 3:领标不符}" },
            work_remark: { type: "string", description: "备注" },
            img: { type: "string", description: "逗号间隔，图片地址" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            print_data: {
                type: "object",
                properties: {
                    result: { type: "boolean" },
                    data: {
                        type: "object",
                        properties: {
                            print: {
                                type: "object",
                                properties: {
                                    cmd: { type: "string" },
                                    requestID: { type: "number" },
                                    version: { type: "string" },
                                    task: {
                                        type: "object",
                                        properties: {
                                            taskID: { type: "string" },
                                            preview: { type: "boolean" },
                                            previewType: { type: "string" },
                                            firstDocumentNumber: { type: "number" },
                                            totalDocumentCount: { type: "number" },
                                            documents: {
                                                type: "array",
                                                items: {
                                                    type: "object",
                                                    properties: {
                                                        documentID: { type: "string" },
                                                        contents: {
                                                            type: "array",
                                                            items: {
                                                                type: "object",
                                                                properties: {
                                                                    data: {
                                                                        type: "object",
                                                                        properties: {
                                                                            title: { type: "string" },
                                                                            user_id: { type: "string" },
                                                                            work_id: { type: "string" },
                                                                            type: { type: "string" },
                                                                            as_refund_position: { type: "string" },
                                                                            qr_code: { type: "string" },
                                                                        },
                                                                    },
                                                                    templateURL: { type: "string" },
                                                                },
                                                            },
                                                        },
                                                    },
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                    msg: { type: "string" },
                },
                description: "打印标签",
            },
            id: { type: "string" },
        },
    },
    requestFunctionName: "createUnreasonWord",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [创建拒收工单↗](http://yapi.yishou.com/project/128/interface/api/34019) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/createUnreasonWord`
 */
export const createUnreasonWord = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(createUnreasonWordRequestConfig, requestData), ...args);
};
createUnreasonWord.requestConfig = createUnreasonWordRequestConfig;
/**
 * 接口 [售后工单-修改商品件数↗](http://yapi.yishou.com/project/128/interface/api/34020) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/updateGoodsNum`
 */
const updateGoodsNumRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/updateGoodsNum",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["unreason_id", "num"],
        properties: {
            unreason_id: { type: "string", description: "拒收id" },
            num: { type: "string", description: "件数" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "updateGoodsNum",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [售后工单-修改商品件数↗](http://yapi.yishou.com/project/128/interface/api/34020) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/updateGoodsNum`
 */
export const updateGoodsNum = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updateGoodsNumRequestConfig, requestData), ...args);
};
updateGoodsNum.requestConfig = updateGoodsNumRequestConfig;
/**
 * 接口 [售后工单-重打标签↗](http://yapi.yishou.com/project/128/interface/api/34021) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/restartPrintData`
 */
const restartPrintDataRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/restartPrintData",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["unreason_id", "num"],
        properties: {
            unreason_id: { type: "string", description: "拒收工单id" },
            num: { type: "string", description: "次数" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            print_data: {
                type: "object",
                properties: {
                    result: { type: "boolean" },
                    data: {
                        type: "object",
                        properties: {
                            print: {
                                type: "object",
                                properties: {
                                    cmd: { type: "string" },
                                    requestID: { type: "number" },
                                    version: { type: "string" },
                                    task: {
                                        type: "object",
                                        properties: {
                                            taskID: { type: "string" },
                                            preview: { type: "boolean" },
                                            previewType: { type: "string" },
                                            firstDocumentNumber: { type: "number" },
                                            totalDocumentCount: { type: "number" },
                                            documents: {
                                                type: "array",
                                                items: {
                                                    type: "object",
                                                    properties: {
                                                        documentID: { type: "string" },
                                                        contents: {
                                                            type: "array",
                                                            items: {
                                                                type: "object",
                                                                properties: {
                                                                    data: {
                                                                        type: "object",
                                                                        properties: {
                                                                            title: { type: "string" },
                                                                            user_id: { type: "string" },
                                                                            work_id: { type: "string" },
                                                                            type: { type: "string" },
                                                                            as_refund_position: { type: "string" },
                                                                            qr_code: { type: "string" },
                                                                        },
                                                                    },
                                                                    templateURL: { type: "string" },
                                                                },
                                                                required: ["data", "templateURL"],
                                                            },
                                                        },
                                                    },
                                                    required: ["documentID", "contents"],
                                                },
                                                description: "打印多次次，document多少次",
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                    msg: { type: "string" },
                },
            },
        },
    },
    requestFunctionName: "restartPrintData",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [售后工单-重打标签↗](http://yapi.yishou.com/project/128/interface/api/34021) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/restartPrintData`
 */
export const restartPrintData = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(restartPrintDataRequestConfig, requestData), ...args);
};
restartPrintData.requestConfig = restartPrintDataRequestConfig;
/**
 * 接口 [pc点货-非我司改标规则配置↗](http://yapi.yishou.com/project/128/interface/api/34022) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `GET /erp/UnreasonWorkOrder/getIdentityUnreasonSetting`
 */
const getIdentityUnreasonSettingRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/getIdentityUnreasonSetting",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        identity: { type: "string", description: "身份" },
                        not_us_goods_num: { type: "string", description: "非我司改标数量" },
                        involving_supply_num: { type: "string", description: "涉及商家数" },
                    },
                    required: ["identity", "not_us_goods_num", "involving_supply_num"],
                },
            },
        },
    },
    requestFunctionName: "getIdentityUnreasonSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [pc点货-非我司改标规则配置↗](http://yapi.yishou.com/project/128/interface/api/34022) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `GET /erp/UnreasonWorkOrder/getIdentityUnreasonSetting`
 */
export const getIdentityUnreasonSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getIdentityUnreasonSettingRequestConfig, requestData), ...args);
};
getIdentityUnreasonSetting.requestConfig = getIdentityUnreasonSettingRequestConfig;
/**
 * 接口 [导出配置用户id模板↗](http://yapi.yishou.com/project/128/interface/api/34023) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `GET /erp/UnreasonWorkOrder/getUserSettingImportTemplate`
 */
const getUserSettingImportTemplateRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/getUserSettingImportTemplate",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string", description: "文件" } } },
    requestFunctionName: "getUserSettingImportTemplate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [导出配置用户id模板↗](http://yapi.yishou.com/project/128/interface/api/34023) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `GET /erp/UnreasonWorkOrder/getUserSettingImportTemplate`
 */
export const getUserSettingImportTemplate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getUserSettingImportTemplateRequestConfig, requestData), ...args);
};
getUserSettingImportTemplate.requestConfig = getUserSettingImportTemplateRequestConfig;
/**
 * 接口 [pc点货-导入非我司改标用户id↗](http://yapi.yishou.com/project/128/interface/api/34024) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/importUserUnreasonSetting`
 */
const importUserUnreasonSettingRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/importUserUnreasonSetting",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["file"],
        properties: { file: { type: "file", tsType: "FileData" } },
    },
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string", description: "异常文件" } } },
    requestFunctionName: "importUserUnreasonSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [pc点货-导入非我司改标用户id↗](http://yapi.yishou.com/project/128/interface/api/34024) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/importUserUnreasonSetting`
 */
export const importUserUnreasonSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importUserUnreasonSettingRequestConfig, requestData), ...args);
};
importUserUnreasonSetting.requestConfig = importUserUnreasonSettingRequestConfig;
/**
 * 接口 [售后点货↗](http://yapi.yishou.com/project/128/interface/api/34025) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @标签 `#2904非我司改标`
 * @请求头 `POST /erp/Work/getWorkGoods`
 */
const getWorkGoodsRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Work/getWorkGoods",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            work_goods: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        goods_kh: { type: "string" },
                        work_id: { type: "string" },
                        goods_img: { type: "string" },
                        tally_num: { type: "string" },
                        co_val: { type: "string" },
                        si_val: { type: "string" },
                        is_exception: { type: "string", tag: "#2904非我司改标", description: "是否异常显示" },
                    },
                },
            },
        },
    },
    requestFunctionName: "getWorkGoods",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [售后点货↗](http://yapi.yishou.com/project/128/interface/api/34025) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @标签 `#2904非我司改标`
 * @请求头 `POST /erp/Work/getWorkGoods`
 */
export const getWorkGoods = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getWorkGoodsRequestConfig, requestData), ...args);
};
getWorkGoods.requestConfig = getWorkGoodsRequestConfig;
/**
 * 接口 [拒收列表↗](http://yapi.yishou.com/project/128/interface/api/34033) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/getList`
 */
const getListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/getList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["page", "pagesize"],
        properties: {
            id: { type: "string", description: "id" },
            work_id: { type: "string", description: "售后工单id" },
            customer_work_id: { type: "string", description: "客服工单id" },
            back_shipping_no: { type: "string", description: "寄回运单号" },
            unpacking_express_no: { type: "string", description: "拆包运单号" },
            mail_express_no: { type: "string", description: "寄出快递单号" },
            goods_no: { type: "string", description: "货号" },
            user_id: { type: "string", description: "用户id" },
            status: { type: "string", description: "状态{1待审核, 2通过, 3驳回}" },
            "submit_time[]": { type: "string", description: "拆包时间" },
            "handle_time[]": { type: "string", description: "处理时间" },
            is_excel: { type: "string", description: "" },
            page: { type: "string", description: "" },
            pagesize: { type: "string", description: "" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            total: { type: "number" },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "id 用于处理交互" },
                        work_id: { type: "string", description: "售后工单id" },
                        customer_work_id: { type: "string", description: "客服工单id" },
                        user_id: { type: "string" },
                        back_shipping_no: { type: "string", description: "寄回运单号" },
                        unpacking_express_no: { type: "string", description: "拆包运单号" },
                        mail_express_no: { type: "string", description: "寄出快递单号" },
                        goods_no: { type: "string", description: "货号" },
                        goods_num: { type: "string", description: "件数" },
                        img: { type: "string" },
                        phone_number: { type: "string", description: "用户手机" },
                        as_refund_position: { type: "string" },
                        status: { type: "string", description: "审核状态" },
                        custom_result: { type: "string", description: "0未处理 {1:弃件, 2:寄出, 3:重新入库}" },
                        quick_remark: { type: "string" },
                        work_remark: { type: "string" },
                        storehouse_remark: { type: "string" },
                        is_validate: { type: "string" },
                        created_at: { type: "string" },
                        updated_at: { type: "string" },
                        type: { type: "string" },
                        submit_time: { type: "string", description: "拆包时间" },
                        handle_time: { type: "string", description: "处理时间" },
                        submit_admin_id: { type: "string" },
                        goods_img: { type: "string", description: "商品图片" },
                        no: { type: "string", description: "拒收工单id" },
                        submit_admin: { type: "string", description: "拆包人" },
                        evidence_img: { type: "array", items: { type: "string" }, description: "图片" },
                        status_msg: { type: "string", description: "状态" },
                        remark: { type: "string", description: "备注" },
                        custom_result_msg: { type: "string", description: "处理结果" },
                    },
                },
            },
        },
    },
    requestFunctionName: "getList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [拒收列表↗](http://yapi.yishou.com/project/128/interface/api/34033) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/getList`
 */
export const getList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getListRequestConfig, requestData), ...args);
};
getList.requestConfig = getListRequestConfig;
/**
 * 接口 [仓储通过拒收工单↗](http://yapi.yishou.com/project/128/interface/api/34035) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/adoptUnreasonWork`
 */
const adoptUnreasonWorkRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/adoptUnreasonWork",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id", "storehouse_remark"],
        properties: {
            id: { type: "string", description: "工单id" },
            storehouse_remark: { type: "string", description: "仓库备注" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "adoptUnreasonWork",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [仓储通过拒收工单↗](http://yapi.yishou.com/project/128/interface/api/34035) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/adoptUnreasonWork`
 */
export const adoptUnreasonWork = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(adoptUnreasonWorkRequestConfig, requestData), ...args);
};
adoptUnreasonWork.requestConfig = adoptUnreasonWorkRequestConfig;
/**
 * 接口 [仓储驳回拒收工单↗](http://yapi.yishou.com/project/128/interface/api/34036) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/rejectUnreasonWork`
 */
const rejectUnreasonWorkRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/rejectUnreasonWork",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: { id: { type: "string", description: "工单id" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "rejectUnreasonWork",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [仓储驳回拒收工单↗](http://yapi.yishou.com/project/128/interface/api/34036) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/rejectUnreasonWork`
 */
export const rejectUnreasonWork = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(rejectUnreasonWorkRequestConfig, requestData), ...args);
};
rejectUnreasonWork.requestConfig = rejectUnreasonWorkRequestConfig;
/**
 * 接口 [处理结果为弃件↗](http://yapi.yishou.com/project/128/interface/api/34037) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/handleDiscardResult`
 */
const handleDiscardResultRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/handleDiscardResult",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: { type: "object", required: ["id"], properties: { id: { type: "string" } } },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "handleDiscardResult",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [处理结果为弃件↗](http://yapi.yishou.com/project/128/interface/api/34037) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/handleDiscardResult`
 */
export const handleDiscardResult = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(handleDiscardResultRequestConfig, requestData), ...args);
};
handleDiscardResult.requestConfig = handleDiscardResultRequestConfig;
/**
 * 接口 [处理结果为寄出↗](http://yapi.yishou.com/project/128/interface/api/34038) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/handleMailResult`
 */
const handleMailResultRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/handleMailResult",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["mailExpressNo", "id"],
        properties: { mailExpressNo: { type: "string", description: "寄出单号" }, id: { type: "string", description: "" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "handleMailResult",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [处理结果为寄出↗](http://yapi.yishou.com/project/128/interface/api/34038) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/handleMailResult`
 */
export const handleMailResult = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(handleMailResultRequestConfig, requestData), ...args);
};
handleMailResult.requestConfig = handleMailResultRequestConfig;
/**
 * 接口 [处理结果为重新入库↗](http://yapi.yishou.com/project/128/interface/api/34039) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/handleRestartInStockResult`
 */
const handleRestartInStockResultRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/handleRestartInStockResult",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id", "reason_type"],
        properties: {
            id: { type: "string" },
            reason_type: { type: "string", description: "重新入库原因: 1=首次豁免,2=误判." },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "handleRestartInStockResult",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [处理结果为重新入库↗](http://yapi.yishou.com/project/128/interface/api/34039) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/handleRestartInStockResult`
 */
export const handleRestartInStockResult = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(handleRestartInStockResultRequestConfig, requestData), ...args);
};
handleRestartInStockResult.requestConfig = handleRestartInStockResultRequestConfig;
/**
 * 接口 [日志列表↗](http://yapi.yishou.com/project/128/interface/api/34040) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/getLog`
 */
const getLogRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/getLog",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: { type: "object", required: ["id"], properties: { id: { type: "string" } } },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string" },
                        admin_id: { type: "string" },
                        unreason_work_order_id: { type: "string" },
                        content: { type: "string" },
                        created_at: { type: "string" },
                        updated_at: { type: "string" },
                        event: { type: "string", description: "事件" },
                        admin_name: { type: "string", description: "操作人" },
                    },
                    required: [
                        "id",
                        "admin_id",
                        "unreason_work_order_id",
                        "content",
                        "created_at",
                        "updated_at",
                        "event",
                        "admin_name",
                    ],
                },
            },
        },
    },
    requestFunctionName: "getLog",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [日志列表↗](http://yapi.yishou.com/project/128/interface/api/34040) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/getLog`
 */
export const getLog = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getLogRequestConfig, requestData), ...args);
};
getLog.requestConfig = getLogRequestConfig;
/**
 * 接口 [清空用户id配置↗](http://yapi.yishou.com/project/128/interface/api/34081) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `GET /erp/UnreasonWorkOrder/clearUnreasonUserIdSetting`
 */
const clearUnreasonUserIdSettingRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/clearUnreasonUserIdSetting",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "clearUnreasonUserIdSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [清空用户id配置↗](http://yapi.yishou.com/project/128/interface/api/34081) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `GET /erp/UnreasonWorkOrder/clearUnreasonUserIdSetting`
 */
export const clearUnreasonUserIdSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(clearUnreasonUserIdSettingRequestConfig, requestData), ...args);
};
clearUnreasonUserIdSetting.requestConfig = clearUnreasonUserIdSettingRequestConfig;
/**
 * 接口 [售后工单-待发布删除↗](http://yapi.yishou.com/project/128/interface/api/34082) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/deleteUnreason`
 */
const deleteUnreasonRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/deleteUnreason",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: { type: "object", required: ["unreason_id"], properties: { unreason_id: { type: "string" } } },
    responseDataJsonSchema: { type: "string" },
    requestFunctionName: "deleteUnreason",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [售后工单-待发布删除↗](http://yapi.yishou.com/project/128/interface/api/34082) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/deleteUnreason`
 */
export const deleteUnreason = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(deleteUnreasonRequestConfig, requestData), ...args);
};
deleteUnreason.requestConfig = deleteUnreasonRequestConfig;
/**
 * 接口 [获取上次的数据值↗](http://yapi.yishou.com/project/128/interface/api/34177) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/getLastTimeNotPublish`
 */
const getLastTimeNotPublishRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/getLastTimeNotPublish",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["user_id"],
        properties: { user_id: { type: "string", description: "用户id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            img: { type: "array", items: { type: "string" }, description: "图片数组" },
            back_shipping_no: { type: "string", description: "寄回运单号" },
            unpacking_express_no: { type: "string", description: "拆包运单号" },
            as_refund_position: { type: "string", description: "仓区" },
            goods_num: { type: "string", description: "商品件数" },
            quick_remark: { type: "array", items: { type: "string" }, description: "快速备足" },
            work_remark: { type: "string", description: "工单备注" },
        },
    },
    requestFunctionName: "getLastTimeNotPublish",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取上次的数据值↗](http://yapi.yishou.com/project/128/interface/api/34177) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/getLastTimeNotPublish`
 */
export const getLastTimeNotPublish = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getLastTimeNotPublishRequestConfig, requestData), ...args);
};
getLastTimeNotPublish.requestConfig = getLastTimeNotPublishRequestConfig;
/**
 * 接口 [設置誤判時間↗](http://yapi.yishou.com/project/128/interface/api/34600) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/setMisjudgmentTime`
 */
const setMisjudgmentTimeRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/setMisjudgmentTime",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["dayNum"],
        properties: { dayNum: { type: "string", description: "驳回时间(天)" } },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "setMisjudgmentTime",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [設置誤判時間↗](http://yapi.yishou.com/project/128/interface/api/34600) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/setMisjudgmentTime`
 */
export const setMisjudgmentTime = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setMisjudgmentTimeRequestConfig, requestData), ...args);
};
setMisjudgmentTime.requestConfig = setMisjudgmentTimeRequestConfig;
/**
 * 接口 [获取误判时间↗](http://yapi.yishou.com/project/128/interface/api/34615) 的 **请求配置**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/getisjudgmentTime`
 */
const getisjudgmentTimeRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/UnreasonWorkOrder/getisjudgmentTime",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: { dayNum: { type: "integer", description: "14" } },
        additionalProperties: false,
    },
    requestFunctionName: "getisjudgmentTime",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取误判时间↗](http://yapi.yishou.com/project/128/interface/api/34615) 的 **请求函数**
 *
 * @分类 [非我司改标-拒收工单↗](http://yapi.yishou.com/project/128/interface/api/cat_3386)
 * @请求头 `POST /erp/UnreasonWorkOrder/getisjudgmentTime`
 */
export const getisjudgmentTime = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getisjudgmentTimeRequestConfig, requestData), ...args);
};
getisjudgmentTime.requestConfig = getisjudgmentTimeRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/unReasonableRefund3386.js